import { ComponentProps } from 'react'
import { Link, Path } from 'react-router'

import { astraTwMerge } from '../Utilities/astraTwMerge'
import { useUserMenuContext } from './AstraUserMenuContext'

type UserMenuLinkProps = ComponentProps<typeof Link> & {
    to: string | Partial<Path>
}
type UserMenuDivProps = ComponentProps<'div'> & {
    to?: never
}
type UserMenuItemProps = UserMenuLinkProps | UserMenuDivProps

export const UserMenuItem = ({ className, children, ...props }: UserMenuItemProps) => {
    const itemClassName = astraTwMerge(
        'col-span-full grid h-7 grid-cols-subgrid items-center gap-x-2 rounded-lg px-2 [&>:first-child]:justify-self-center',
        className
    )
    const { closeMenu } = useUserMenuContext()

    if ('to' in props && props.to !== undefined) {
        return (
            <Link
                className={astraTwMerge(itemClassName, 'hover:bg-surface-backdrop/10')}
                role="menuitem"
                {...props}
                onClick={e => {
                    props.onClick?.(e)
                    if (!e.defaultPrevented) {
                        closeMenu()
                    }
                }}
            >
                {children}
            </Link>
        )
    }

    return (
        <div
            className={astraTwMerge(itemClassName, props.onClick && 'cursor-pointer hover:bg-surface-backdrop/10')}
            role="menuitem"
            tabIndex={props.onClick ? 0 : -1}
            {...props}
            onKeyDown={
                props.onClick
                    ? event => {
                          props.onKeyDown?.(event)
                          if (!event.defaultPrevented && props.onClick && event.key === 'Enter') {
                              event.preventDefault()
                              event.currentTarget.click()
                          }
                      }
                    : props.onKeyDown
            }
            onClick={
                props.onClick
                    ? e => {
                          props.onClick?.(e)
                          if (!e.defaultPrevented) {
                              closeMenu()
                          }
                      }
                    : undefined
            }
        >
            {children}
        </div>
    )
}
